module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-ALTER-2-25-small-0fe38dbfd3e80cb122b53b2bb9afdd09.png";